import { useEffect, useState } from "react";
import { getCustomProducts } from "redux/services/Home/genericSearch";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";
import Banner from "./Banner";
import Categories from "./Categories";
import CategorySection from "./CategorySection";
import OfferComponent from "./HomeComponent/offerComponent";
import SaleComponent from "./HomeComponent/saleComponent";
import SpecialOffer from "./SpecialOffers";
import MailingListModal from "./MailingList";
import useWindowSize from "utils/useWindowSize";
import axios from "api/axiosController";
import HomePageGridComponent from "./HomePageGrid/HomePageGridComponent";
import ResellBanner from "./ResellBanner/ResellBanner";
import HomeEssentialsBanner from "./HomeEssentialsBanner";
import HomePageMetaTags from "./HomePageMetaTags";

interface productDetails {
  productName: string;
  price: string;
  discountedPrice: string;
  image: string;
}

interface SectionDetails {
  componentType?: "SALE" | "OFFER" | "VENDOR";
  heading: string;
  subHeading: string;
  category: string;
  products: productDetails[];
}

const Home: React.FC = () => {
  const [bannerData, setBannerData] = useState<{
    images: { src: string; category: string }[];
  }>({
    images: [],
  });
  const [homePageSection, setHomePageSection] = useState<SectionDetails[]>([]);
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const user = useSelector((state: RootState) => state.user.user);

  const size = useWindowSize();
  useEffect(() => {
    const fetchBanners = async () => {
      let uri = "/dashboard/banner-urls";
      const response = await axios.get(uri);
      if (response && response.data.ResponseBody) {
        let ele: { images: { src: string; category: string }[] } = {
          images: [],
        };
        response.data.ResponseBody.map(
          (data: { url: string; search: string }) => {
            ele.images.push({ src: data.url, category: data.search });
          }
        );
        setBannerData(ele);
      }
    };

    fetch("homePage.json")
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        return response;
      })
      .then((data) => {
        setHomePageSection(data);
      });
    getCustomProducts("home").then((res) => {});

    fetchBanners();
  }, []);
  // need to make changes here:-

  useEffect(() => {
    const delayTimeout = setTimeout(() => {
      const popupShown = sessionStorage.getItem("popupShown");

      // check if popup is already shown in this session
      if (popupShown === "true") {
        return;
      }

      setModalOpen(true);
      sessionStorage.setItem("popupShown", "true");
    }, 6000); // Adjust delay when modal should appear

    return () => clearTimeout(delayTimeout);
  }, []);

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  return (
    <>
      <HomePageMetaTags />
      {size.x > 1000 && <Banner data={bannerData} />}
      {/* <Categories /> */}
      {Object.keys(user).length === 0
        ? size.x > 1000 && (
            <MailingListModal open={modalOpen} onClose={handleCloseModal} />
          )
        : null}

      {homePageSection.map((containerData) => {
        if (containerData.componentType === "SALE") {
          return <SaleComponent data={containerData} />;
        } else if (containerData.componentType === "OFFER") {
          return <OfferComponent data={containerData} />;
        } else if (containerData.componentType === "VENDOR") {
          return <SpecialOffer />;
        } else if (containerData.componentType === "RESELL") {
          return <HomeEssentialsBanner />;
        } else if (containerData.componentType === "HOMEPAGEGRID") {
          return <HomePageGridComponent />;
        }
        return "";
      })}
      {/* <CategorySection /> */}
    </>
  );
};

export default Home;
